import IReport from './IReport';
import generateCSV from "../../services/CSVController";
import save from 'save-file';

export interface ITransactionFeeReportItem {
    created_on: string;
    hash_id: string;
    order_status: string
    yoello_processing_total_amount: number
}
export default async function generateTransactionFeeReportFile(transactionFeeReportArray: ITransactionFeeReportItem[] | undefined, reportObj: IReport,venueName:string) {
    /**If the stock report isn't undefined and the its greater than 0 try generate CSV */
    if (transactionFeeReportArray !== undefined && transactionFeeReportArray.length > 0) {
        const arrayOfKeys = ["hash_id", "created_on", "order_status", "yoello_processing_total_amount","venue_name","serial_id"];
        const arrayOfHeaders = ["Order ID", "Timestamp of order", "Order Status", "Yoello Transaction Fee","Venue Name", "Venue ID"];
        const mapTransactionFeeReport = transactionFeeReportArray.map((transactionFeeObject) => {
            return {
                ...transactionFeeObject,
                hash_id: transactionFeeObject.hash_id,
                created_on: transactionFeeObject.created_on,
                order_status: transactionFeeObject.order_status,
                yoello_processing_total_amount: transactionFeeObject.yoello_processing_total_amount
            };
        });
        const csvString = generateCSV(mapTransactionFeeReport, arrayOfKeys, arrayOfHeaders);
        save(csvString, `${venueName}-Transaction-Fee-Report${reportObj.start_date_time}to${reportObj.end_date_time}.csv`);
        return;
    }
}